import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LookupItem } from './lookup-item.model';
import { LocalStorageService } from './local-storage.service';
import { OnlineStatusService, OnlineStatusType } from "ngx-online-status";
import { catchError, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { error } from 'console';

/**
 * Retrieves the lookup data from the server or in the absence of internet, pull from local storage.
 */
@Injectable({
  providedIn: 'root'
})
export class LookupDataService {

  static potID = NaN;
  static lineID = NaN;
  static pelID = NaN;
  static _HmsGearTypes: LookupItem[] = [
    new LookupItem('Harpoon', 18),
    new LookupItem('Rod and Reel', 22),
    new LookupItem('Troll Line', 71),
    new LookupItem('Pole', 72),
    new LookupItem('Deep Set Buoy Gear', 264)
  ];
  static _HmsDBSGTypes: LookupItem[] = [
    new LookupItem('Standard', 261),
    new LookupItem('Linked', 262),
    new LookupItem('StandardNight', 265),
    new LookupItem('LinkedNight', 266)
  ];

  private readonly REQUEST_TIMEOUT_MS = 4 * 1000;

  private _ports: BehaviorSubject<LookupItem[]>;
  private _permitTypes: BehaviorSubject<LookupItem[]>;
  private _gearTypes: BehaviorSubject<LookupItem[]>;
  private _species: BehaviorSubject<LookupItem[]>;

  private _hmsPorts: LookupItem[] = [
    new LookupItem('ALAMEDA', 4209, 'PORT'),
    new LookupItem('ANACORTES', 4080, 'PORT'),
    new LookupItem('ASTORIA/WARRENTON', 30, 'PORT'),
    new LookupItem('AVALON', 4390, 'PORT'),
    new LookupItem('AVILA/PORT SAN LUIS', 4106, 'PORT'),
    new LookupItem('BANDON', 4103, 'PORT'),
    new LookupItem('BAY CENTER', 4079, 'PORT'),
    new LookupItem('BELLINGHAM', 3935, 'PORT'),
    new LookupItem('BERKELEY', 4327, 'PORT'),
    new LookupItem('BLAINE', 4225, 'PORT'),
    new LookupItem('BODEGA BAY', 4089, 'PORT'),
    new LookupItem('BOLINAS', 4123, 'PORT'),
    new LookupItem('BROOKINGS', 91, 'PORT'),
    new LookupItem('CAMPBELL RIVER', 4335, 'PORT'),
    new LookupItem('CANNON BEACH', 4180, 'PORT'),
    new LookupItem('CHANNEL ISLANDS HARBOR', 4121, 'PORT'),
    new LookupItem('CHINOOK', 4098, 'PORT'),
    new LookupItem('COOS BAY/CHARLESTON', 122, 'PORT'),
    new LookupItem('COWICHAN BAY', 4325, 'PORT'),
    new LookupItem('CRAIG', 4226, 'PORT'),
    new LookupItem('CRESCENT CITY', 125, 'PORT'),
    new LookupItem('DANA POINT', 4336, 'PORT'),
    new LookupItem('DEPOE BAY', 133, 'PORT'),
    new LookupItem('EAGLE HARBOR', 4176, 'PORT'),
    new LookupItem('EUREKA', 156, 'PORT'),
    new LookupItem('EVERETT', 4085, 'PORT'),
    new LookupItem('FLORENCE', 4076, 'PORT'),
    new LookupItem('FORT BRAGG', 164, 'PORT'),
    new LookupItem('FORT LADNER', 4224, 'PORT'),
    new LookupItem('FRENCH CREEK', 4324, 'PORT'),
    new LookupItem('FRIDAY HARBOR', 4232, 'PORT'),
    new LookupItem('GEARHART', 4175, 'PORT'),
    new LookupItem('GIG HARBOR', 4345, 'PORT'),
    new LookupItem('GOLD BEACH', 4101, 'PORT'),
    new LookupItem('GOLETA', 10621, 'PORT'),
    new LookupItem('HALF MOON BAY/PRINCETON', 4119, 'PORT'),
    new LookupItem('HAMMOND', 4380, 'PORT'),
    new LookupItem('HONOLULU', 3937, 'PORT'),
    new LookupItem('HUMBOLDT BAY', 4337, 'PORT'),
    new LookupItem('ILWACO', 216, 'PORT'),
    new LookupItem('KETCHIKAN', 4082, 'PORT'),
    new LookupItem('KEWALO BASIN', 237, 'PORT'),
    new LookupItem('KING COVE', 4228, 'PORT'),
    new LookupItem('KODIAK', 4177, 'PORT'),
    new LookupItem('LA PUSH', 3932, 'PORT'),
    new LookupItem('LEVUKA/SUVA', 259, 'PORT'),
    new LookupItem('LONG BEACH', 4215, 'PORT'),
    new LookupItem('LOS ANGELES', 4078, 'PORT'),
    new LookupItem('MISSION BAY', 4183, 'PORT'),
    new LookupItem('MORRO BAY', 306, 'PORT'),
    new LookupItem('MOSS LANDING/MONTEREY', 308, 'PORT'),
    new LookupItem('NANAIMO', 4178, 'PORT'),
    new LookupItem('NEAH BAY', 4081, 'PORT'),
    new LookupItem('NEWPORT', 322, 'PORT'),
    new LookupItem('NEWPORT BEACH', 4388, 'PORT'),
    new LookupItem('OAKLAND', 341, 'PORT'),
    new LookupItem('OCEAN SHORES', 4122, 'PORT'),
    new LookupItem('OCEANSIDE', 4213, 'PORT'),
    new LookupItem('OXNARD', 4344, 'PORT'),
    new LookupItem('PACIFIC CITY', 4075, 'PORT'),
    new LookupItem('PAGO PAGO', 356, 'PORT'),
    new LookupItem('PARADISE CAY', 4329, 'PORT'),
    new LookupItem('PETERSBURG', 4115, 'PORT'),
    new LookupItem('PILLAR POINT HARBOR', 4181, 'PORT'),
    new LookupItem('POINT LOMA/SHELTER ISLAND', 4182, 'PORT'),
    new LookupItem('PORT ALBERNI', 4112, 'PORT'),
    new LookupItem('PORT ANGELES', 4074, 'PORT'),
    new LookupItem('PORT EDWARD', 4332, 'PORT'),
    new LookupItem('PORT HARDY', 4091, 'PORT'),
    new LookupItem('PORT HUENEME', 4124, 'PORT'),
    new LookupItem('PORT ORCHARD', 4114, 'PORT'),
    new LookupItem('PORT ORFORD', 4077, 'PORT'),
    new LookupItem('PORT TOWNSEND', 3938, 'PORT'),
    new LookupItem('POULSBO', 4092, 'PORT'),
    new LookupItem('PRINCE RUPERT', 4331, 'PORT'),
    new LookupItem('REEDSPORT/WINCHESTER BAY(AKA WINDY BAY)', 408, 'PORT'),
    new LookupItem('RICHMOND, CA', 4214, 'PORT'),
    new LookupItem('SAN DIEGO', 420, 'PORT'),
    new LookupItem('SAN FRANCISCO', 3936, 'PORT'),
    new LookupItem('SAN PEDRO', 421, 'PORT'),
    new LookupItem('SANTA BARBARA', 4208, 'PORT'),
    new LookupItem('SANTA CRUZ', 3939, 'PORT'),
    new LookupItem('SAUSALITO', 4233, 'PORT'),
    new LookupItem('SEATTLE', 4035, 'PORT'),
    new LookupItem('SHELTER COVE', 4328, 'PORT'),
    new LookupItem('SITKA', 4086, 'PORT'),
    new LookupItem('SOOKE', 4326, 'PORT'),
    new LookupItem('SOUTH BEND', 4083, 'PORT'),
    new LookupItem('STEVESTON/RICHMOND', 4126, 'PORT'),
    new LookupItem('SUVA', 471, 'PORT'),
    new LookupItem('TACOMA', 3455, 'PORT'),
    new LookupItem('TAURANGA', 4094, 'PORT'),
    new LookupItem('TERMINAL ISLAND', 482, 'PORT'),
    new LookupItem('TILLAMOOK BAY/GARIBALDI', 488, 'PORT'),
    new LookupItem('TOKELAND', 4110, 'PORT'),
    new LookupItem('UCLUELET', 4111, 'PORT'),
    new LookupItem('VANCOUVER', 4084, 'PORT'),
    new LookupItem('VENTURA', 4088, 'PORT'),
    new LookupItem('VICTORIA', 4125, 'PORT'),
    new LookupItem('WARRENTON/HAMMOND', 4173, 'PORT'),
    new LookupItem('WESTPORT/GRAYS HARBOR', 530, 'PORT'),
    new LookupItem('WHANGAREI', 540, 'PORT'),
    new LookupItem('WINSLOW', 4113, 'PORT')
  ];
  static _hmsFishingModes: LookupItem[] = [
    new LookupItem('Fish', 3),
    new LookupItem('Port', 4),
    new LookupItem('Tran', 6)
  ]
  static _hmsSetSpecies: LookupItem[] = [
    new LookupItem('Pacific bluefin tuna', 1, 'HMSSPECIES'),
    new LookupItem('Yellowfin tuna', 3, 'HMSSPECIES'),
    new LookupItem('Albacore', 4, 'HMSSPECIES'),
    new LookupItem('Bigeye tuna', 5, 'HMSSPECIES'),
    new LookupItem('Skipjack tuna', 8, 'HMSSPECIES'),
    new LookupItem('Swordfish', 19, 'HMSSPECIES'),
    new LookupItem('Shortfin mako shark', 158, 'HMSSPECIES'),
    new LookupItem('Blue shark', 163, 'HMSSPECIES'),
    new LookupItem('Common thresher shark', 401, 'HMSSPECIES'),
    new LookupItem('Dorado / dolphinfish / mahi', 402, 'HMSSPECIES'),
    new LookupItem('Opah', 403, 'HMSSPECIES'),
    new LookupItem('Yellowtail', 404, 'HMSSPECIES')
  ];

  private _trawlPorts: BehaviorSubject<LookupItem[]>;
  private _netTypes: BehaviorSubject<LookupItem[]>;
  private _targetSpecies: BehaviorSubject<LookupItem[]>;
  private _prioritySpecies: BehaviorSubject<LookupItem[]>;
  private _trawlSpecies: BehaviorSubject<LookupItem[]>;


  constructor(private http: HttpClient, private onlineStatusService: OnlineStatusService) {
    this._ports = new BehaviorSubject<LookupItem[]>([]);
    this._permitTypes = new BehaviorSubject<LookupItem[]>([]);
    this._gearTypes = new BehaviorSubject<LookupItem[]>([]);
    this._species = new BehaviorSubject<LookupItem[]>([]);
    this._trawlPorts = new BehaviorSubject<LookupItem[]>([]);
    this._netTypes = new BehaviorSubject<LookupItem[]>([]);
    this._targetSpecies = new BehaviorSubject<LookupItem[]>([]);
    this._prioritySpecies = new BehaviorSubject<LookupItem[]>([]);
    this._trawlSpecies = new BehaviorSubject<LookupItem[]>([]);
  }

  /**
   * On every successful login, lookup data needs to be:
   *   1. Retrieved from PSMFC servers if a connection is present, 
   *   2. Assuming data retrieval is successful, store or update existing lookup data on the device, 
   *   3. Transformed from JSON to objects and made available to the right components
   *
   * Different types of lookup data will be separated into different lists (species, ports, gear types...) and an observable to get that data
   * will be made available to the right components. Those components will subscribe to these observables and feed the data to dropdowns/autocompletes
  */
  retrieveLookupData() {
    LocalStorageService.getLookupData().then(data => {
      this.deserializeJSON(data.data ?? [], 'GF', false);
      this.deserializeJSON(data.trawlData ?? [], 'TRAWL', false);

      if (this.onlineStatusService.getStatus() == OnlineStatusType.ONLINE) {
        console.log('Connection detected, requesting lookup data from server...');
  
        const lookupTrawlRequest = this.http.get<any>(`${environment.apiURL}/LookupTrawl`, {
          headers: new HttpHeaders({ 'Authorization': 'Bearer ' + LocalStorageService.accessToken })
        }).pipe(
          timeout(this.REQUEST_TIMEOUT_MS),
          catchError(error => {
            console.error('LookupTrawl request failed:', error);
            return of(null); // Return null in case of error
          })
        );
  
        const lookupRequest = this.http.get<any>(`${environment.apiURL}/Lookup`, {
          headers: new HttpHeaders({ 'Authorization': 'Bearer ' + LocalStorageService.accessToken })
        }).pipe(
          timeout(this.REQUEST_TIMEOUT_MS),
          catchError(error => {
            console.error('Lookup request failed:', error);
            return of(null); // Return null in case of error
          })
        );

        combineLatest([lookupTrawlRequest, lookupRequest]).subscribe({
          next: ([lookupTrawlData, lookupData]) => {
            this.deserializeJSON(lookupData ?? [], 'GF');
            this.deserializeJSON(lookupTrawlData ?? [], 'TRAWL');
            LocalStorageService.storeLookupData(lookupData ?? [], lookupTrawlData ?? []);
          },
          error: (error: any) => console.error('Error retrieving lookup data:', error)
        });
      }
    });
  }


  /**
   * Given the data in raw JSON we transform it into lists of lookup items, then sort the lists and give them to the BehaviorSubjects of this class.
   * @param lookupData JSON array of lookup data retrieved either from the server or pulled from local storage
   */
  deserializeJSON(lookupData: any[], fishery: 'GF' | 'TRAWL', saveData: boolean = true) {
    console.log('Deserializing...');
    let portList: LookupItem[] = [];
    let permitList: LookupItem[] = [];
    let gearTypeList: LookupItem[] = [];
    let speciesList: LookupItem[] = [];
    let targetSpeciesList: LookupItem[] = [];
    let prioritySpeciesList: LookupItem[] = [];
    let netTypeList: LookupItem[] = [];


    lookupData.forEach(item => {
      //Create new lookup item object
      //Map fields from item to that object
      //Put object in proper list
      switch (item.lookupType) {
        case 'GEAR':
          if (item.code == 'Pot') LookupDataService.potID = item.id;
          if (item.code == 'Longline') LookupDataService.lineID = item.id;
          if (item.code == 'Other Hook-and-Line' || item.code == 'Other Hook & Line') LookupDataService.pelID = item.id;
          break;
        case "PORT":
          portList.push(LookupItem.transformAnonymous(item));
          break;
        case "PERMITTYPE":
          permitList.push(LookupItem.transformAnonymous(item));
          break;
        case "LONGLINETYPE":
        case "POTTYPE":
        case "PELAGICTYPE":
          gearTypeList.push(LookupItem.transformAnonymous(item));
          break;
        case "SPECIES":
          speciesList.push(LookupItem.transformAnonymous(item));
          break;
        case "TARGETSTRATEGY":
          targetSpeciesList.push(LookupItem.transformAnonymous(item));
          break;
        case "PRIORITYSPECIES":
          prioritySpeciesList.push(LookupItem.transformAnonymous(item));
          break;
        case "NETTYPE":
          netTypeList.push(LookupItem.transformAnonymous(item));
          break;
      }
    });


    portList.sort((a, b) => 0 - (a.name < b.name ? 1 : -1));
    permitList.sort((a, b) => 0 - (a.name < b.name ? 1 : -1));
    speciesList.sort((a, b) => 0 - (a.name < b.name ? 1 : -1));
    gearTypeList.sort((a, b) => 0 - (a.name < b.name ? 1 : -1));
    targetSpeciesList.sort((a, b) => 0 - (a.name < b.name ? 1 : -1));
    prioritySpeciesList.sort((a, b) => 0 - (a.name < b.name ? 1 : -1));
    netTypeList.sort((a, b) => 0 - (a.name < b.name ? 1 : -1));

    if (saveData) LocalStorageService.checkUserSpecies(speciesList);

    //Assign lists
    if (portList.length > 0) (fishery == 'GF' ? this._ports : this._trawlPorts).next(portList);
    if (permitList.length > 0) this._permitTypes.next(permitList);
    if (gearTypeList.length > 0) this._gearTypes.next(gearTypeList);
    if (speciesList.length > 0) (fishery == 'GF' ? this._species : this._trawlSpecies).next(speciesList);
    if (targetSpeciesList.length > 0) this._targetSpecies.next(targetSpeciesList);
    if (prioritySpeciesList.length > 0) this._prioritySpecies.next(prioritySpeciesList);
    if (netTypeList.length > 0) this._netTypes.next(netTypeList);
  }


  getPortsObservable(): Observable<LookupItem[]> {
    return this._ports.asObservable();
  }


  getPermitTypeObservable(): Observable<LookupItem[]> {
    return this._permitTypes.asObservable();
  }


  getGearTypeObservable(): Observable<LookupItem[]> {
    return this._gearTypes.asObservable();
  }


  getSpeciesObservable(fishery: string): Observable<LookupItem[]> {
    return (fishery == 'Groundfish' ? this._species : this._trawlSpecies).asObservable();
  }

  getHmsPorts(): LookupItem[] {
    return this._hmsPorts;
  }

  getHmsSetSpecies(): LookupItem[] {
    return LookupDataService._hmsSetSpecies;
  }

  getTrawlPortsObservable(): Observable<LookupItem[]> {
    return this._trawlPorts.asObservable();
  }

  getNetTypesObservable(): Observable<LookupItem[]> {
    return this._netTypes.asObservable();
  }

  getTargetSpeciesObservable(): Observable<LookupItem[]> {
    return this._targetSpecies.asObservable();
  }

  getPrioritySpeciesObservable(): Observable<LookupItem[]> {
    return this._prioritySpecies.asObservable();
  }

}
